import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Button } from 'semantic-ui-react';
import Modal from '../../modules/foundation/components/Modal';
import { ChildrenPropType } from '../../services/proptypes';
import IconElement from '../IconElement';
var defaultProps = {
  iconAs: 'icon'
};
export default function HoursOfOperationModal(props) {
  var iconAs = props.iconAs,
    children = props.children;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  function showModal() {
    setOpen(true);
  }
  function hideModal() {
    setOpen(false);
  }
  return /*#__PURE__*/React.createElement(Modal, {
    className: "hoo-modal",
    dimmer: "inverted",
    open: open,
    onClose: hideModal,
    trigger: iconAs === 'icon' ? /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "hoo-modal-trigger",
      onClick: showModal
    }, /*#__PURE__*/React.createElement(IconElement, {
      iconType: "clock",
      element: /*#__PURE__*/React.createElement("span", null, "See Hours"),
      iconPosition: "left"
    })) : /*#__PURE__*/React.createElement(Button, {
      icon: "clock",
      secondary: true,
      onClick: showModal
    })
  }, /*#__PURE__*/React.createElement(Modal.Header, null, /*#__PURE__*/React.createElement("div", null, "Hours Of Operation")), /*#__PURE__*/React.createElement(Modal.Content, null, children));
}
HoursOfOperationModal.defaultProps = defaultProps;